import React from 'react';

import { ReactComponent as NewLiliLogo } from '../../../../assets/icons/svg/icon-new-lili-logo.svg';

interface IProps {
    children: React.ReactNode;
    backgroundColor?: string;
    className?: string;
    hideLiliIcon?: boolean ;
}

const LoginCard = ({
  children, backgroundColor, className, hideLiliIcon,
}: IProps) => (
  <div className={`${className} ${backgroundColor} absolute m-auto rounded-md p-8`}>
    { !hideLiliIcon && <NewLiliLogo className='mb-6' />}
    {children}
  </div>
);

export default LoginCard;
